import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import styles from './TeamProfileQuote.module.css'

export interface TeamProfileQuoteProps {
  quote: string
  author: string
  theme?: ComponentTheme
  testID?: string
}

export default function TeamProfileQuote({
  quote,
  author,
  theme = ComponentTheme.primary,
  testID,
}: TeamProfileQuoteProps) {
  return (
    <Fixture theme={theme}>
      <Container>
        <div className={styles.base} data-testid={testID}>
          <div className={styles.content}>
            <Text size={TextSizes.magSecondaryBodyLrg} className={styles.quote}>
              {quote}
            </Text>
            <Text size={TextSizes.primaryTitleMed} className={styles.author}>
              {author}
            </Text>
          </div>
        </div>
      </Container>
    </Fixture>
  )
}
